import {
  POST_LOGIN_LOADING,
  POST_LOGIN_DONE,
  POST_LOGIN_ERROR,
  //
  AUTH_LOGOUT_LOADING,
  AUTH_LOGOUT_DONE,
  AUTH_LOGOUT_ERROR,
  //
  POST_PASS_MAIL_LOADING,
  POST_PASS_MAIL_DONE,
  POST_PASS_MAIL_ERROR,
  //
  RESET_PASS_LOADING,
  RESET_PASS_DONE,
  RESET_PASS_ERROR,
  //
  AUTH_VERIFY_LOADING,
  AUTH_VERIFY_DONE,
  AUTH_VERIFY_ERROR,
  //
  EMAIL_CHECK_LOADING,
  EMAIL_CHECK_DONE,
  EMAIL_CHECK_ERROR,
  //
  RESEND_EMAIL_LOADING,
  RESEND_EMAIL_DONE,
  RESEND_EMAIL_ERROR,

  PUT_GUEST_DATA_LOADING,
  PUT_GUEST_DATA_DONE,
  PUT_GUEST_DATA_ERROR,

  GET_LIST_AREA_LOADING,
  GET_LIST_AREA_DONE,
  GET_LIST_AREA_ERROR,

  GET_LIST_INDUSTRY_LOADING,
  GET_LIST_INDUSTRY_DONE,
  GET_LIST_INDUSTRY_ERROR,

  GET_LIST_TRADE_ROLE_LOADING,
  GET_LIST_TRADE_ROLE_DONE,
  GET_LIST_TRADE_ROLE_ERROR,

  FETCH_DIAL_COUNTRY_CODE_LOADING,
  FETCH_DIAL_COUNTRY_CODE_DONE,
  FETCH_DIAL_COUNTRY_CODE_ERROR,

  CHECK_RESET_PASS_LOADING,
  CHECK_RESET_PASS_DONE,
  CHECK_RESET_PASS_ERROR

} from './actions'

export default {
  [POST_LOGIN_LOADING] (state) {
    state.isLoading = true
  },

  [POST_LOGIN_DONE] (state, items) {
    state.items = items
    state.token = items.data.session.token
    state.profile = items.data.profile
    state.isLoading = false
  },

  [POST_LOGIN_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },
  // ---------- logout ------------
  [AUTH_LOGOUT_LOADING] (state) {
    state.isLoading = true
  },

  [AUTH_LOGOUT_DONE] (state, items) {
    state.items = items
    state.token = null
    state.isLoading = false
  },

  [AUTH_LOGOUT_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  // ---------- Password Mail ------------
  [POST_PASS_MAIL_LOADING] (state) {
    state.isLoading = true
  },

  [POST_PASS_MAIL_DONE] (state, checkEmail) {
    state.checkEmail = checkEmail
    state.errorCheckEmail = {}
    state.isLoading = false
  },

  [POST_PASS_MAIL_ERROR] (state, errorCheckEmail) {
    state.errorCheckEmail = errorCheckEmail
    state.isLoading = false
  },

  // ---------- Password Rest ------------
  [RESET_PASS_LOADING] (state) {
    state.isLoading = true
  },

  [RESET_PASS_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [RESET_PASS_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [CHECK_RESET_PASS_LOADING] (state) {
    state.isLoadingCheckResetpwd = true
  },

  [CHECK_RESET_PASS_DONE] (state, items) {
    state.checkResetpwd = items
    state.isLoadingCheckResetpwd = false
    state.errorCheckResetpwd = null
  },

  [CHECK_RESET_PASS_ERROR] (state, error) {
    state.errorCheckResetpwd = error
    state.isLoadingCheckResetpwd = false
  },

  // ---------- Auth Verify ------------

  [AUTH_VERIFY_LOADING] (state) {
    state.isLoading = true
  },

  [AUTH_VERIFY_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [AUTH_VERIFY_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  // ---------- Email Checking ------------

  [EMAIL_CHECK_LOADING] (state) {
    state.isLoading = true
  },

  [EMAIL_CHECK_DONE] (state, items) {
    state.checkEmail = items
    state.isLoading = false
    state.errorCheckEmail = false
  },

  [EMAIL_CHECK_ERROR] (state, error) {
    state.errorCheckEmail = error
    state.checkEmail = null
    state.isLoading = false
  },

  // ---------- Resend Email  ------------

  [RESEND_EMAIL_LOADING] (state) {
    state.isLoading = true
  },

  [RESEND_EMAIL_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [RESEND_EMAIL_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  // ---------- Input Guest Personal Data  ------------

  [PUT_GUEST_DATA_LOADING] (state) {
    state.isLoadingGuestPersonal = true
  },

  [PUT_GUEST_DATA_DONE] (state, items) {
    state.guestPersonal = items
    state.isLoadingGuestPersonal = false
  },

  [PUT_GUEST_DATA_ERROR] (state, error) {
    state.errorGuestPersonal = error
    state.isLoadingGuestPersonal = false
  },

  // ---------- Register : Area List  ------------
  [GET_LIST_AREA_LOADING] (state) {
    state.isLoadingGetListArea = true
  },

  [GET_LIST_AREA_DONE] (state, items) {
    state.getListArea = items
    state.isLoadingGetListArea = false
    state.errorGetListArea = false
  },

  [GET_LIST_AREA_ERROR] (state, error) {
    state.errorGetListArea = error
    state.isLoadingGetListArea = false
  },

  // ---------- Register : Industry List  ------------
  [GET_LIST_INDUSTRY_LOADING] (state) {
    state.isLoadingGetListIndustry = true
  },

  [GET_LIST_INDUSTRY_DONE] (state, items) {
    state.getListIndustry = items
    state.isLoadingGetListIndustry = false
    state.errorGetListIndustry = false
  },

  [GET_LIST_INDUSTRY_ERROR] (state, error) {
    state.errorGetListIndustry = error
    state.isLoadingGetListIndustry = false
  },

  // ---------- Register : Company Trade Role List  ------------
  [GET_LIST_TRADE_ROLE_LOADING] (state) {
    state.isLoadingGetListTradeRole = true
  },

  [GET_LIST_TRADE_ROLE_DONE] (state, items) {
    state.getListTradeRole = items
    state.isLoadingGetListTradeRole = false
    state.errorGetListTradeRole = false
  },

  [GET_LIST_TRADE_ROLE_ERROR] (state, error) {
    state.errorGetListTradeRole = error
    state.isLoadingGetListTradeRole = false
  },

  // ---------- Register : Dial Code List ------------
  [FETCH_DIAL_COUNTRY_CODE_LOADING] (state) {
    state.isLoadingDialcode = true
  },
  [FETCH_DIAL_COUNTRY_CODE_DONE] (state, items) {
    state.dialcode = items
    state.errorDialcode = null
    state.isLoadingDialcode = false
  },
  [FETCH_DIAL_COUNTRY_CODE_ERROR] (state, error) {
    state.errorDialcode = error
    state.dialcode = null
    state.isLoadingDialcode = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js